<template>
  <v-dialog v-model="propDialogo" width="500px" persistent>
    <v-card style="padding: 15px">
      <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
        @click="clearFields(); $emit('closeDialogo')">mdi-close-circle</v-icon>
      <div style="text-align: center; justify-content: center">
        <div class="ml-4 mr-4">
          <h1 style="line-height: 1.2; color: black; text-align: center">
            {{ this.propNuevo ? "NUEVA" : "EDITAR" }} NOTICIA
          </h1>
        </div>
        <div class="line" style="padding: 10px; margin: 10px; border-radius: 5px; overflow: hidden;">
          <!-- -------------------- -->
          <div>
            <v-row>
              <v-col cols="6">
                <h2>FECHA</h2>
                <v-text-field class="adaptative-field" type="date" v-model="formulario.fecha_noticia" outlined dense
                  placeholder="Ingrese título" />
              </v-col>
              <v-col cols="6">
                <h2>DESTACADO</h2>
                <v-checkbox class="adaptative-field mt-1" v-model="formulario.destacado" label="DESTACAR" />
              </v-col>
            </v-row>
            <input type="file" ref="fileInput" @change="handleImageUpload" accept="image/*" style="display: none" />
            <div class="line center"
              style="align-content: center; margin-left: -3%; height: 100px; width: 106%; display: flex; align-items: center;">
              <!-- Botón Izquierda -->
              <v-btn icon @click="scrollLeft" style="margin-right: 8px;">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <!-- Contenedor fijo para imágenes -->
              <div class="pb-1 pt-1" ref="imageSlider"
                style="display: flex; overflow: hidden; width: 100%; scroll-behavior: smooth;">
                <v-card class="mr-2 center" v-for="(img, index) in imagePreviews" :key="index"
                  style="width: 80px; height: 80px; position: relative; flex-shrink: 0;">
                  <v-img :src="img" cover height="100%" width="100%"></v-img>

                  <!-- Botón C para cambiar imagen -->
                  <v-btn icon x-small :color="$ajustes.colorTexto2" :style="{ backgroundColor: $ajustes.colorTexto1 }"
                    style="position: absolute; bottom: 30px; right: 4px;" @click="triggerReplace(index)">
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>

                  <!-- Botón X para eliminar imagen -->
                  <v-btn icon x-small :color="$ajustes.colorTexto2" :style="{ backgroundColor: $ajustes.colorTexto1 }"
                    style="position: absolute; bottom: 2px; right: 4px;" @click="removeImage(index)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>

                  <!-- Input para reemplazar imagen -->
                  <input :ref="'replaceInput' + index" type="file" @change="handleReplaceImage($event, index)"
                    accept="image/*" style="display: none" />
                </v-card>
                <v-card class="line" style="align-content: center ;" @click="$refs.fileInput.click()">
                  <v-btn icon class="ma-4">
                    <v-icon x-large>mdi-plus-circle</v-icon>
                  </v-btn>
                </v-card>
              </div>
              <!-- Botón Derecha -->
              <v-btn icon @click="scrollRight" style="margin-left: 8px;">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>

            </div>
            <!-- Botón para añadir imagen -->
            <span style="width: 100%; text-align: left;">Imagen (alto: 800px; ancho: 800px)</span>
            <div>
              <h2>TÍTULO</h2>
              <v-text-field class="adaptative-field" v-model="formulario.titulo" outlined dense
                placeholder="Ingrese título" />
            </div>
            <div>
              <h2>DESCRIPCIÓN</h2>
              <v-textarea class="adaptative-field" v-model="formulario.detalles" placeholder="Ingrese descripción"
                outlined no-resize />
            </div>
            <div>
              <h2>ENLACE</h2>
              <v-text-field class="adaptative-field" v-model="formulario.enlace" outlined dense
                placeholder="Ingrese enlace" />
            </div>
            <br>
            <v-btn block :color="$ajustes.colorTexto2" style="color: white"
              @click="propNuevo ? crearNoticia() : actualizarNoticia()">
              <h2>GUARDAR</h2>
            </v-btn>
          </div>
          <!-- -------------------- -->
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    propCrear: { type: Function },
    propActualizar: { type: Function },
    propNuevo: { type: Boolean },
    propDialogo: { type: Boolean },
    propNoticia: { type: Object }
  },
  data() {
    return {
      formulario: {
        id: '',
        fecha_noticia: '',
        destacado: '',
        imagenes: [],
        titulo: '',
        detalles: '',
        enlace: '',
      },
      imagePreviews: [],
      imagePreviewOld: null,
      days: Array.from({ length: 31 }, (_, i) =>
        String(i + 1).padStart(2, "0")
      ),
      months: Array.from({ length: 12 }, (_, i) =>
        String(i + 1).padStart(2, "0")
      ),
      years: Array.from({ length: 7 }, (_, i) => String(2024 + i)),
      hours: Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0")),
      minutes: Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0")),
    };
  },
  mounted() { },
  watch: {
    propNoticia() {
      this.clearFields()
      this.setFields()
    }
  },
  methods: {
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formulario.imagenes.push(file);
        this.imagePreviews.push(URL.createObjectURL(file));

        this.$nextTick(() => {
          const container = this.$refs.imageSlider;
          container.scrollLeft = container.scrollWidth; // Desplaza al final
        });
      }
    },
    triggerReplace(index) {
      this.$refs['replaceInput' + index][0].click(); // activamos el input oculto
    },

    handleReplaceImage(event, index) {
      const file = event.target.files[0];
      if (file) {
        // Reemplaza la imagen
        this.formulario.imagenes.splice(index, 1, file);
        this.imagePreviews.splice(index, 1, URL.createObjectURL(file));
      }
    },
    removeImage(index) {
      const removed = this.formulario.imagenes[index];

      // Si es una ruta (string), guárdala para eliminar en el backend
      if (typeof removed === 'string') {
        if (!this.formulario.imagenes_a_eliminar) {
          this.formulario.imagenes_a_eliminar = [];
        }
        this.formulario.imagenes_a_eliminar.push(removed);
      }

      // Eliminar de arrays visibles
      this.formulario.imagenes.splice(index, 1);
      this.imagePreviews.splice(index, 1);
    },

    scrollLeft() {
      const container = this.$refs.imageSlider;
      container.scrollBy({ left: -100, behavior: "smooth" }); // Desplaza 100px a la izquierda
    },
    scrollRight() {
      const container = this.$refs.imageSlider;
      container.scrollBy({ left: 100, behavior: "smooth" }); // Desplaza 100px a la derecha
    },
    async crearNoticia() {
      // Validar que haya fecha, título, detalles y al menos una imagen en el array
      if (
        !this.formulario.fecha_noticia ||
        !this.formulario.titulo ||
        !this.formulario.detalles ||
        !this.formulario.imagenes ||
        this.formulario.imagenes.length === 0
      ) {
        this.sms = "Faltan campos por llenar";
        return;
      }

      const form = new FormData();
      form.append("fecha_noticia", this.formulario.fecha_noticia);
      form.append("destacado", this.formulario.destacado);
      form.append("titulo", this.formulario.titulo);
      form.append("detalles", this.formulario.detalles);
      form.append("enlace", this.formulario.enlace);
      // Agregar todas las imágenes al formData (como 'imagenes[]' para backend que recibe array)
      this.formulario.imagenes.forEach(imgFile => {
        form.append("imagenes[]", imgFile);
      });

      try {
        const result = await this.propCrear(form); // Enviar el formData al backend
        const _result = result.data;
        if (_result.status === "success") {
          this.clearFields();
          this.$emit("closeDialogo");
        } else {
          this.sms = "Error al registrar. Intente nuevamente.";
        }
      } catch (error) {
        console.error(error);
        this.sms = "Error inesperado.";
      }
    },

    async actualizarNoticia() {
      if (!this.formulario.titulo || !this.formulario.detalles) {
        this.sms = "Faltan campos por llenar";
        return;
      }
      const form = new FormData();
      form.append("id", this.formulario.id);
      form.append("fecha_noticia", this.formulario.fecha_noticia);
      form.append("destacado", this.formulario.destacado);
      form.append("titulo", this.formulario.titulo);
      form.append("detalles", this.formulario.detalles);
      form.append("enlace", this.formulario.enlace);
      this.formulario.imagenes.forEach(img => {
        if (img instanceof File) {
          form.append("imagenes[]", img); // para backend como array de nuevas imágenes
        }
      });

      // Rutas a eliminar
      if (this.formulario.imagenes_a_eliminar && this.formulario.imagenes_a_eliminar.length > 0) {
        this.formulario.imagenes_a_eliminar.forEach(ruta => {
          form.append("imagenes_a_eliminar[]", ruta); // rutas como strings
        });
      }
      try {
        for (let pair of form.entries()) {
          console.log(pair[0], pair[1]);
        }
        const result = await this.propActualizar(form); // Enviamos como formulario
        if (result.status === "success") {
          this.clearFields()
          this.$emit("closeDialogo");
        } else {
          this.sms = "Error al registrar. Intente nuevamente.";
        }
      } catch (error) {
        console.error(error);
        this.sms = "Error inesperado.";
      }
    },
    splitDateTime(dateTime) {
      const [date, time] = dateTime.split(", "); // Divide en fecha y hora
      const [year, month, day] = date.split("/"); // Divide la fecha en partes
      const [hour, minute, second] = time.split(":"); // Divide la hora en partes

      return {
        year,
        month,
        day,
        hour,
        minute,
        second,
      };
    },
    setFields() {
      this.formulario.id = this.propNoticia.id
      this.formulario.titulo = this.propNoticia.titulo
      this.formulario.detalles = this.propNoticia.detalles
      this.formulario.imagenes = this.propNoticia.imagenes_ruta
      this.formulario.destacado = this.propNoticia.destacado
      this.formulario.enlace = this.propNoticia.enlace
      this.formulario.fecha_noticia
        = this.propNoticia.fecha_noticia

      try {
        // Parsear correctamente la cadena JSON
        const rutas = JSON.parse(this.propNoticia.imagenes_ruta || '[]');

        this.imagePreviews = rutas.map(img => `${this.$env.pathImg}/${img}`);
        this.formulario.imagenes = rutas; // Mantener referencia de rutas
      } catch (e) {
        console.error('Error al parsear imagenes_ruta:', e);
        this.imagePreviews = [];
        this.formulario.imagenes = [];
      }
    },
    clearFields() {
      this.formulario = {
        id: '',
        fecha_noticia: '',
        destacado: false,
        imagenes: [],
        imagenes_a_eliminar: [],
        titulo: '',
        detalles: '',
        enlace: ''
      };
      this.imagePreviews = [];
      this.imagePreviewOld = null;
    },
    genDate() {
      const options = {
        timeZone: "America/Guayaquil", // Configura la zona horaria de Guayaquil
        hour12: false, // Usar formato de 24 horas
      };

      const now = new Date();

      // Usar toLocaleString para obtener la fecha en la zona horaria especificada
      const year = now.toLocaleString("es-EC", { ...options, year: "numeric" });
      const month = String(
        now.toLocaleString("es-EC", { ...options, month: "2-digit" })
      ).padStart(2, "0");
      const day = String(
        now.toLocaleString("es-EC", { ...options, day: "2-digit" })
      ).padStart(2, "0");
      const hours = String(
        now.toLocaleString("es-EC", { ...options, hour: "2-digit" })
      ).padStart(2, "0");
      const minutes = String(
        now.toLocaleString("es-EC", { ...options, minute: "2-digit" })
      ).padStart(2, "0");
      const seconds = String(
        now.toLocaleString("es-EC", { ...options, second: "2-digit" })
      ).padStart(2, "0");
      return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style scoped>
.adaptative-field {
  margin-bottom: -20px
}
</style>
